import { useAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { useQuery } from "react-query";
import { debounce } from "lodash";
import {
  getOpcosOptions,
  validateProjectName
} from "../api/projectsHttpClient";
import { selectedPackageAtom } from "./useSelectPackage";

const useEnterDetails = () => {
  const [selectedPackage] = useAtom(selectedPackageAtom);
  const { data } = useQuery("getOpcos", getOpcosOptions);

  const validateUniqueProjectName = useCallback(
    async (name: string) => {
      if (!name || !name.trim()) {
        return true;
      }
      
      return await validateProjectName(name);
    },
    []
  );

  const dynamicFields = useMemo(() => selectedPackage.fields, [selectedPackage.fields]);

  return {
    opcos: data || [],
    validateUniqueProjectName,
    dynamicFields,
    packageId: selectedPackage.id
  };
};

export default useEnterDetails;
